import { QuizFormProvider } from '../../hooks/quiz-form-context';
import QuizQuestions from './Navigator/QuizQuestions';

export const QuizMain = () => {

    return (
        <>
            <div>
                <QuizFormProvider>
                    <QuizQuestions />
                </QuizFormProvider>
            </div>
        </>
    );
};
